import { request } from "./request.js";

async function get(key) {
    return await request("/payment", { key: key }, "POST");
}

async function save(data) {
    return await request("/payment/save", data, "POST");
}

export { save, get };
